import { END_POINTS } from "constants/APIConstant";
import fetch from "../auth/FetchInterceptor";

const JwtAuthService = {};

JwtAuthService.login = async function (personalKey, password) {
  var data = { personalKey: personalKey, password: password };
  return await fetch.post(END_POINTS.LOGIN, data);
};

JwtAuthService.signUp = function (data) {
  return fetch({
    url: "/auth/signup",
    method: "post",
    headers: {
      "public-request": "true",
    },
    data: data,
  });
};

export default JwtAuthService;
